import { render } from "./IntegrationForm.vue?vue&type=template&id=e233e530&scoped=true"
import script from "./IntegrationForm.vue?vue&type=script&lang=js"
export * from "./IntegrationForm.vue?vue&type=script&lang=js"

import "./IntegrationForm.vue?vue&type=style&index=0&id=e233e530&lang=scss&scoped=true"
import "./IntegrationForm.vue?vue&type=style&index=1&id=e233e530&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e233e530"]])

export default __exports__